import { useContext, useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import MentorPortalService from './MentorPortalService';

const LIVE_TABS = [
    { id: 'dashboard', icon: 'bi bi-house-door-fill', label: 'Dashboard', to: '/alumni/mentorship/dashboard' },
    { id: 'mentees', icon: 'bi bi-people-fill', label: 'My Mentees', to: '/alumni/mentorship/mentees' },
    { id: 'messages', icon: 'bi bi-chat-left-text-fill', label: 'Messages', to: '/alumni/mentorship/messages' },
    { id: 'sessions', icon: 'bi bi-calendar-event-fill', label: 'Sessions', to: '/alumni/mentorship/sessions' },
    { id: 'my-profile', icon: 'bi bi-person-fill', label: 'My Profile', to: '/alumni/mentorship/profile' },
] as const;

const campusLabelFromDomain = (
    domain: Map<string, any[]> | undefined,
    campusId: number | null
): string | null => {
    if (campusId == null || !domain) return null;
    const institutes = domain.get('INSTITUTE_DOMAIN') ?? [];
    const match = institutes.find((item: any) => Number(item?.code) === campusId);
    const label = match?.value == null ? '' : String(match.value).trim();
    if (!label) return null;
    const asNumber = Number(label);
    if (Number.isFinite(asNumber) && asNumber === campusId && String(asNumber) === label) {
        return null;
    }
    return label;
};

const MentorPortalNav = () => {
    const { globalState } = useContext(GlobalContext);
    const [campusId, setCampusId] = useState<number | null>(null);

    useEffect(() => {
        let cancelled = false;
        MentorPortalService.getDashboard()
            .then((dashboard) => {
                if (cancelled) return;
                const mentor = dashboard?.mentor as { campusId?: number | null; campus_id?: number | null } | null;
                const raw = mentor?.campusId ?? mentor?.campus_id ?? null;
                const id = raw == null ? NaN : Number(raw);
                setCampusId(Number.isFinite(id) ? id : null);
            })
            .catch(() => {
                if (!cancelled) setCampusId(null);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    const campusName = useMemo(
        () => campusLabelFromDomain(globalState?.domain, campusId),
        [globalState?.domain, campusId]
    );

    const subtitle = campusName ? `Mentor Portal · ${campusName}` : 'Mentor Portal';

    return (
        <>
            <div className="d-flex align-items-center gap-2 mb-3">
                <div className="fs-1">📘</div>
                <div className="d-flex flex-column">
                    <div className="fw-bold text-dark font-22 lh-base"> Mentorship Module</div>
                    <div className="text-secondary font-14">{subtitle}</div>
                </div>
            </div>
            <div className="card border-0 rounded-3 shadow-sm bg-darker-blue mb-3">
                <div className="d-flex flex-wrap gap-2 p-2">
                    {LIVE_TABS.map((tab) => (
                        <NavLink
                            key={tab.id}
                            to={tab.to}
                            className={({ isActive }) =>
                                `btn  border-0 py-2 px-3 mb-1 rounded-2 d-flex align-items-center gap-2 ${
                                    isActive ? ' btn-success' : 'btn-light'
                                }`
                            }
                            role="presentation"
                            end
                        >
                            <i className={tab.icon}></i> {tab.label}
                        </NavLink>
                    ))}
                </div>
            </div>
        </>
    );
};

export default MentorPortalNav;
